import React, { useMemo } from 'react';
import SectionRenderer from './SectionRenderer';
import '../DashboardNew/Grid.css';
import './Bhima.css'; // Import Bhima styles
import usePrefetchInitialData from 'hooks/usePrefetchInitialData';
import validateConfig from '../DashboardNew/validateConfig';
import bhimaLogo from 'images/bhimaMainLogo.png';
import { BhimaDashboardFilters } from './BhimaDashboardFilters';

function clampWidth(width, maxColumns) {
    if (typeof width !== 'number' || width < 1) return 1;
    if (width > maxColumns) return maxColumns;
    return width;
}

export default function GridRenderer({ config, filter, onFilterChange }) {
    const maxColumns = config?.maxColumns || 1;
    const sections = config?.sections || [];
    // Prefetch unique initial data for all sections once
    usePrefetchInitialData(config);

    // Non-intrusive validation in dev/runtime to aid authors
    React.useEffect(() => {
        try {
            const { warnings } = validateConfig(config || {});
            if (Array.isArray(warnings) && warnings.length) {
                // eslint-disable-next-line no-console
                console.warn('[DashboardBhima] layoutConfig warnings:', warnings);
            }
        } catch (_) {
            // noop
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const gridStyle = useMemo(() => ({
        // Use standard grid on desktop, override in CSS for mobile
        '--max-columns': maxColumns
    }), [maxColumns]);

    if (!sections.length) {
        return (
            <div className="bhima-container">
                <div className="bhima-header-row">
                    <img src={bhimaLogo} alt="Logo" className="bhima-header-logo" />
                    {filter && onFilterChange && (
                        <BhimaDashboardFilters filter={filter} onChange={onFilterChange} />
                    )}
                </div>
                <div className="dashboard-new-empty">
                    <span>Dashboard is empty.</span>
                </div>
            </div>
        );
    }

    return (
        <div className="bhima-container">
            <div className="bhima-header-row">
                <img src={bhimaLogo} alt="Logo" className="bhima-header-logo" />
                {filter && onFilterChange && (
                    <BhimaDashboardFilters filter={filter} onChange={onFilterChange} />
                )}
            </div>

            {/* Grid */}
            <div className="bhima-grid" style={gridStyle}>
                {sections.map((section, idx) => {
                    const colSpan = clampWidth(section?.width, maxColumns);
                    const key = section?.id ? `${section.id}-${idx}` : `section-${idx}`;

                    return (
                        <div
                            key={key}
                            className="bhima-grid-item"
                            data-col-span={colSpan}
                            style={{
                                '--col-span': colSpan
                            }}
                        >
                            <SectionRenderer section={section} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
